(ns ui.editor2.sidebar-canva
  (:require [parts.replicant.query :as query]
            [storrito.ui.button :as button]
            [storrito.ui.spinner :as spinner]))

(def canva-icon-new
  "The Canva.com icon."
  [:svg {:width "24" :height "24" :fill "none" :xmlns "http://www.w3.org/2000/svg"} [:circle {:cx "12" :cy "12" :r "12" :fill "#7D2AE7"}] [:circle {:cx "12" :cy "12" :r "12" :fill "url(#a)"}] [:circle {:cx "12" :cy "12" :r "12" :fill "url(#b)"}] [:circle {:cx "12" :cy "12" :r "12" :fill "url(#c)"}] [:circle {:cx "12" :cy "12" :r "12" :fill "url(#d)"}] [:path {:d "M17.18 14.462c-.098 0-.186.083-.276.266-1.024 2.077-2.793 3.546-4.84 3.546-2.367 0-3.833-2.137-3.833-5.088 0-5 2.786-7.891 5.233-7.891 1.143 0 1.842.718 1.842 1.862 0 1.357-.771 2.076-.771 2.554 0 .215.133.345.398.345 1.065 0 2.315-1.223 2.315-2.952 0-1.675-1.459-2.907-3.906-2.907-4.044 0-7.638 3.749-7.638 8.936 0 4.015 2.293 6.669 5.831 6.669 3.755 0 5.926-3.736 5.926-4.949 0-.268-.137-.391-.28-.391Z" :fill "#fff"}] [:defs [:radialGradient#a {:cx "0" :cy "0" :r "1" :gradientUnits "userSpaceOnUse" :gradientTransform "rotate(-49.416 25.433 5.598) scale(18.5619)"} [:stop {:stop-color "#6420FF"}] [:stop {:offset "1" :stop-color "#6420FF" :stop-opacity "0"}]] [:radialGradient#b {:cx "0" :cy "0" :r "1" :gradientUnits "userSpaceOnUse" :gradientTransform "rotate(54.703 .54 7.506) scale(20.9321)"} [:stop {:stop-color "#00C4CC"}] [:stop {:offset "1" :stop-color "#00C4CC" :stop-opacity "0"}]] [:radialGradient#c {:cx "0" :cy "0" :r "1" :gradientUnits "userSpaceOnUse" :gradientTransform "matrix(12.92215 -13.01041 5.98368 5.94309 4.636 21.272)"} [:stop {:stop-color "#6420FF"}] [:stop {:offset "1" :stop-color "#6420FF" :stop-opacity "0"}]] [:radialGradient#d {:cx "0" :cy "0" :r "1" :gradientUnits "userSpaceOnUse" :gradientTransform "matrix(7.52841 17.33054 -29.03243 12.61173 9.815 3.234)"} [:stop {:stop-color "#00C4CC" :stop-opacity ".726"}] [:stop {:offset "0" :stop-color "#00C4CC"}] [:stop {:offset "1" :stop-color "#00C4CC" :stop-opacity "0"}]]]])

(defn entry
  [selected?]
  [:div
   {:class ["flex" "pt-3" "pb-3" "pl-2" "pr-2" "flex-col" "justify-center" "items-center" "gap-1" "rounded-lg" "cursor-pointer" "hover:bg-gray-600"
            (when selected?
              "bg-gray-800")]
    :on {:click [[:store/assoc-in [:editor2 :sidebar-panel] :canva]
                 [:data/query {:query/kind :query/canva-status}]
                 [:data/query {:query/kind :query/canva-list-designs}]]}}
   [:svg {:class ["size-6" (when-not selected? "text-slate-400")]
          :width "24px"
          :height "24px"
          :viewBox "0 0 192 192"
          :xmlns "http://www.w3.org/2000/svg"
          :stroke "currentColor"
          :style "enable-background:new 0 0 192 192"
          :xml:space "preserve"}
    [:g#SVGRepo_bgCarrier {:stroke-width "0"}]
    [:g#SVGRepo_tracerCarrier
     {:stroke-linecap "round" :stroke-linejoin "round"}]
    [:g#SVGRepo_iconCarrier
     [:path {:d "M95.2 170c-11.6 0-22-3.1-30.9-9.1-8.8-6-15.4-14.6-19.7-25.6-2.5-6.4-4-13.4-4.7-21.4-.8-9.5-.2-19.2 1.9-28.7 3.3-15.3 10-28.5 19.8-39.5 9.7-10.8 21.2-18.1 34.3-21.5 5.6-1.5 11.2-2.2 16.5-2.2 6.4 0 12.7 1.1 18.7 3.3 8.9 3.3 15 9 17.9 17 1.4 3.7 1.8 7.6 1.4 12-.6 6.2-2.6 11.7-6 16.4-3.9 5.4-8.6 8.7-14.3 10.1-1 .3-2.1.4-3.3.4-.5 0-.9 0-1.4-.1-1.7-.2-3.2-.9-4.2-2.2-1-1.3-1.4-3-1.2-4.7.3-2 1.1-3.7 1.9-5.1l.3-.6c1.6-3.2 3.1-6.2 3.9-9.4 1.3-5.4 1.3-9.5-.1-13.3-1.5-4-4.3-6.5-8.5-7.5-1.6-.4-3.2-.6-4.8-.6-3.6 0-7.4.9-11.4 2.7C93.4 44 86.7 50 81 58.7c-3.9 6-6.9 12.7-9.1 20.5-1.6 5.6-2.6 11.5-3.2 17.6-.3 2.9-.5 6.3-.5 9.6.1 9.7 1.5 17.4 4.5 24.2 3.3 7.6 7.8 12.9 13.9 16.3 4.1 2.3 8.7 3.5 13.6 3.5.8 0 1.7 0 2.6-.1 10.4-.8 19.6-5.5 28-14.3 4.3-4.5 7.9-9.7 11-15.9.5-.9 1-1.9 1.8-2.7 1-1.1 2.3-1.7 3.7-1.7 1.7 0 3.2.9 4.2 2.5 1.2 2 1.1 4.2.9 5.6-.6 4.1-2.1 8.1-4.6 12.8-7.2 12.9-17.1 22.4-29.4 28.3-6.3 3-13.1 4.7-20.1 5-1.1.1-2.1.1-3.1.1z"
             :style "fill:none;stroke-width:12;stroke-linejoin:round;stroke-miterlimit:10"}]]]
   [:span
    {:class ["text-center" "text-xs" "font-medium" (when-not selected? "text-slate-400")]}
    "Canva"]])

(defn page-selection-panel
  [state]
  (let [{:keys [page-count selected-pages thumbnail-url title edit-url]} (get-in state [:editor2 :canva/page-selection])
        all-selected? (= (count selected-pages) page-count)]
    [:div
     {:class ["flex" "flex-col" "gap-3"]}

     ;; Header with back button
     [:div
      {:class ["flex" "items-center" "gap-2"]}
      [:button
       {:class ["text-gray-400" "hover:text-gray-200" "transition" "p-1" "rounded" "hover:bg-gray-700"]
        :type "button"
        :on {:click [[:editor2/canva-cancel-page-selection]]}}
       [:svg
        {:xmlns "http://www.w3.org/2000/svg"
         :fill "none"
         :viewBox "0 0 24 24"
         :stroke-width "2"
         :stroke "currentColor"
         :class ["w-4" "h-4"]}
        [:path
         {:stroke-linecap "round"
          :stroke-linejoin "round"
          :d "M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"}]]]
      [:span
       {:class ["text-sm" "text-gray-300" "font-medium"]}
       "Select pages to import"]]

     ;; Design preview (thumbnail + title)
     [:div
      {:class ["flex" "items-center" "gap-3" "p-2" "rounded-lg" "bg-gray-800"]}
      (if thumbnail-url
        [:img
         {:src thumbnail-url
          :alt (or title "Design")
          :class ["w-12" "h-12" "rounded" "object-cover" "flex-shrink-0"]}]
        [:div
         {:class ["w-12" "h-12" "rounded" "bg-gray-700" "flex" "items-center" "justify-center" "flex-shrink-0"]}
         [:svg
          {:xmlns "http://www.w3.org/2000/svg"
           :fill "none"
           :viewBox "0 0 24 24"
           :stroke-width "1.5"
           :stroke "currentColor"
           :class ["w-6" "h-6" "text-gray-500"]}
          [:path
           {:stroke-linecap "round"
            :stroke-linejoin "round"
            :d "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"}]]])
      [:div
       {:class ["flex" "flex-col" "min-w-0" "flex-1"]}
       [:span
        {:class ["text-sm" "text-gray-200" "font-medium" "truncate"]}
        (or title "Untitled")]
       [:span
        {:class ["text-xs" "text-gray-400"]}
        (str page-count " pages")]]
      (when edit-url
        [:button
         {:class ["text-gray-400" "hover:text-gray-200" "transition" "p-1.5" "rounded" "hover:bg-gray-700" "flex-shrink-0"]
          :type "button"
          :title "Open in Canva to preview pages"
          :on {:click [[:editor2/canva-open-edit-url edit-url]]}}
         [:svg
          {:xmlns "http://www.w3.org/2000/svg"
           :fill "none"
           :viewBox "0 0 24 24"
           :stroke-width "1.5"
           :stroke "currentColor"
           :class ["w-4" "h-4"]}
          [:path
           {:stroke-linecap "round"
            :stroke-linejoin "round"
            :d "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"}]]])]

     ;; Select all / Deselect all toggle
     [:button
      {:class ["text-xs" "text-blue-400" "hover:text-blue-300" "transition" "text-left"]
       :type "button"
       :on {:click [[:editor2/canva-select-all-pages (not all-selected?)]]}}
      (if all-selected? "Deselect All" "Select All")]

     ;; Page checkboxes
     [:div
      {:class ["flex" "flex-col" "gap-1" "max-h-64" "overflow-y-auto"]}
      (for [page-num (range 1 (inc page-count))]
        (let [selected? (contains? selected-pages page-num)]
          [:label
           {:key page-num
            :class ["flex" "items-center" "gap-2" "px-2" "py-1.5" "rounded" "cursor-pointer"
                    "hover:bg-gray-700" "transition"
                    (when selected? "bg-gray-800")]}
           [:input
            {:type "checkbox"
             :checked selected?
             :class ["rounded" "border-gray-500" "text-blue-500" "focus:ring-blue-500" "bg-gray-700"]
             :on {:click [[:editor2/canva-toggle-page page-num]]}}]
           [:span
            {:class ["text-sm" "text-gray-300"]}
            (str "Page " page-num)]]))]

     ;; Import button
     [:button
      {:class ["w-full" "px-3" "py-2" "text-sm" "font-medium" "bg-blue-600" "text-white" "rounded"
               "hover:bg-blue-700" "transition"
               "disabled:opacity-50" "disabled:cursor-not-allowed"]
       :type "button"
       :disabled (empty? selected-pages)
       :on {:click [[:editor2/canva-confirm-page-selection]]}}
      (str "Import " (count selected-pages) " page" (when (not= 1 (count selected-pages)) "s"))]]))

(defn canva-panel
  [state]
  (let [canva-data (query/get-result state {:query/kind :query/canva-status})
        importing-design-id (get-in state [:editor2 :canva/importing-design-id])]
    [:div
     [:button
      {:class ["w-full" "flex" "items-center" "justify-center" "bg-gray-200" "text-black" "px-3" "py-2" "rounded"
               "disabled:cursor-not-allowed" "disabled:text-gray-700" "disabled:opacity-50"]
       :type "button"
       :on {:click [[:editor2/canva-button-click]]}}
      canva-icon-new
      [:span.ml-2 "Design with Canva"]]
     [:div
      {:class ["flex" "items-center" "justify-between" "my-4"]}
      [:p
       {:class ["text-sm" "text-gray-400"]}
       "Designs of " (get-in canva-data [:connected :canva.user/display-name]) ":"]
      [:button
       {:class ["text-gray-400" "hover:text-gray-200" "transition" "p-1" "rounded" "hover:bg-gray-700"]
        :type "button"
        :title "Refresh design list"
        :on {:click [[:data/query {:query/kind :query/canva-list-designs}]]}}
       [:svg
        {:xmlns "http://www.w3.org/2000/svg"
         :fill "none"
         :viewBox "0 0 24 24"
         :stroke-width "2"
         :stroke "currentColor"
         :class ["w-4" "h-4"]}
        [:path
         {:stroke-linecap "round"
          :stroke-linejoin "round"
          :d "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"}]]]]

     (let [result (query/get-result state {:query/kind :query/canva-list-designs})
           designs (:designs result)]
       [:div
        {:class ["flex" "flex-col" "gap-2"]}
        (if (seq designs)
          ;; Display designs
          [:div
           {:class ["grid" "grid-cols-2" "gap-2"]}
           (for [design designs]
             (let [is-importing? (= (:id design) importing-design-id)]
               [:div
                {:key (:id design)
                 :class ["group" "rounded-lg" "border" "border-gray-600" "hover:border-gray-500" "transition" "flex" "flex-col" "overflow-hidden"]}

                ;; Thumbnail with hover overlay
                [:div
                 {:class ["relative" "w-full" "h-24" "overflow-hidden"]}

                 ;; Thumbnail image or placeholder
                 (if (:thumbnail-url design)
                   [:img
                    {:src (:thumbnail-url design)
                     :alt (:title design)
                     :class ["w-full" "h-full" "object-cover"]}]
                   ;; Placeholder SVG for designs without thumbnail
                   [:div
                    {:class ["w-full" "h-full" "flex" "items-center" "justify-center" "bg-gray-800"]}
                    [:svg
                     {:xmlns "http://www.w3.org/2000/svg"
                      :fill "none"
                      :viewBox "0 0 24 24"
                      :stroke-width "1.5"
                      :stroke "currentColor"
                      :class ["w-12" "h-12" "text-gray-600"]}
                     [:path
                      {:stroke-linecap "round"
                       :stroke-linejoin "round"
                       :d "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"}]]])

                 ;; Loading overlay (shows when importing this design)
                 (when is-importing?
                   [:div
                    {:class ["absolute" "inset-0" "bg-black" "bg-opacity-75" "flex" "flex-col" "items-center" "justify-center" "gap-2"]}
                    [:svg
                     {:class ["animate-spin" "h-8" "w-8" "text-white"]
                      :xmlns "http://www.w3.org/2000/svg"
                      :fill "none"
                      :viewBox "0 0 24 24"}
                     [:circle
                      {:class ["opacity-25"]
                       :cx "12"
                       :cy "12"
                       :r "10"
                       :stroke "currentColor"
                       :stroke-width "4"}]
                     [:path
                      {:class ["opacity-75"]
                       :fill "currentColor"
                       :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]]
                    [:span
                     {:class ["text-xs" "text-white" "font-medium"]}
                     "Importing..."]])

                 ;; Dark overlay on hover (only when not importing)
                 (when-not is-importing?
                   [:div
                    {:class ["absolute" "inset-0" "bg-black" "bg-opacity-0" "group-hover:bg-opacity-50" "transition-opacity" "duration-200"]}])

                 ;; Action buttons (visible on hover, hidden when importing)
                 (when-not is-importing?
                   [:div
                    {:class ["absolute" "inset-0" "flex" "flex-col" "items-center" "justify-center" "gap-1.5" "opacity-0" "group-hover:opacity-100" "transition-opacity" "duration-200" "p-2"]}

                    ;; Format selector text
                    [:span
                     {:class ["text-xs" "text-white" "font-medium"]}
                     "Import as:"]

                    ;; Format selection buttons (Video / Image)
                    [:div
                     {:class ["flex" "gap-1" "w-full"]}
                     ;; Import as Video button
                     [:button
                      {:class ["flex-1" "px-2" "py-1.5" "text-xs" "font-medium" "bg-purple-600" "text-white" "rounded" "hover:bg-purple-700" "transition" "shadow-lg"]
                       :type "button"
                       :on {:click [[:editor2/canva-sidebar-import-design
                                    {:design-id (:id design)
                                     :format :video
                                     :page-count (:page-count design)
                                     :thumbnail-url (:thumbnail-url design)
                                     :title (:title design)
                                     :edit-url (get-in design [:urls :edit_url])}]]}}
                      "Video"]
                     ;; Import as Image button
                     [:button
                      {:class ["flex-1" "px-2" "py-1.5" "text-xs" "font-medium" "bg-blue-600" "text-white" "rounded" "hover:bg-blue-700" "transition" "shadow-lg"]
                       :type "button"
                       :on {:click [[:editor2/canva-sidebar-import-design
                                    {:design-id (:id design)
                                     :format :image
                                     :page-count (:page-count design)
                                     :thumbnail-url (:thumbnail-url design)
                                     :title (:title design)
                                     :edit-url (get-in design [:urls :edit_url])}]]}}
                      "Img"]]

                    ;; Edit in Canva button
                    [:button
                     {:class ["w-full" "px-3" "py-1.5" "text-xs" "font-medium" "bg-white" "text-gray-900" "rounded" "hover:bg-gray-100" "transition" "shadow-lg"]
                      :type "button"
                      :on {:click [[:editor2/canva-open-edit-url (get-in design [:urls :edit_url])]]}}
                     "Edit in Canva"]])]

                ;; Title
                [:div.flex.justify-between.w-full
                 [:p
                  {:class ["text-xs" "truncate" "p-2" "text-gray-300"]}
                  (or (:title design) "Untitled")]
                 [:p
                  {:class ["text-xs" "truncate" "p-2" "text-gray-300"]}
                  (or (:page-count design) 1)]]

                ]))]
          ;; No designs
          [:p
           {:class ["text-sm" "text-gray-500" "text-center" "py-4"]}
           (if (query/loading? state {:query/kind :query/canva-list-designs})
             (spinner/vire-spinner-xs)
             "No designs found")])])]))

(defn canva-connect-panel
  [state]
  [:div
   {:class ["flex" "flex-col" "items-center" "justify-center" "gap-6" "p-6" "text-center"]}

   ;; Canva icon (large)
   [:div
    {:class ["w-20" "h-20"]}
    [:svg {:width "80" :height "80" :viewBox "0 0 60 60" :fill "none" :xmlns "http://www.w3.org/2000/svg"} [:defs [:radialGradient#_3529512508__a {:cx "0" :cy "0" :r "1" :gradientUnits "userSpaceOnUse" :gradientTransform "scale(.77341) rotate(-49.416 1.37 .302)"} [:stop {:stop-color "#6420FF"}] [:stop {:offset "1" :stop-color "#6420FF" :stop-opacity "0"}]] [:radialGradient#_3529512508__b {:cx "0" :cy "0" :r "1" :gradientUnits "userSpaceOnUse" :gradientTransform "rotate(54.703 .022 .313) scale(.87217)"} [:stop {:stop-color "#00C4CC"}] [:stop {:offset "1" :stop-color "#00C4CC" :stop-opacity "0"}]] [:radialGradient#_3529512508__c {:cx "0" :cy "0" :r "1" :gradientUnits "userSpaceOnUse" :gradientTransform "matrix(.53842 -.5421 .24932 .24763 .193 .886)"} [:stop {:stop-color "#6420FF"}] [:stop {:offset "1" :stop-color "#6420FF" :stop-opacity "0"}]] [:radialGradient#_3529512508__d {:cx "0" :cy "0" :r "1" :gradientUnits "userSpaceOnUse" :gradientTransform "matrix(.31368 .7221 -1.20968 .52549 .409 .135)"} [:stop {:stop-color "#00C4CC" :stop-opacity ".726"}] [:stop {:offset "0" :stop-color "#00C4CC"}] [:stop {:offset "1" :stop-color "#00C4CC" :stop-opacity "0"}]] [:pattern#_3529512508__e {:width "1" :height "1" :patternContentUnits "objectBoundingBox"} [:path {:fill "#7D2AE7" :d "M0 0h1v1H0z"}] [:path {:fill "url(#_3529512508__a)" :d "M0 0h1v1H0z"}] [:path {:fill "url(#_3529512508__b)" :d "M0 0h1v1H0z"}] [:path {:fill "url(#_3529512508__c)" :d "M0 0h1v1H0z"}] [:path {:fill "url(#_3529512508__d)" :d "M0 0h1v1H0z"}]]] [:circle {:cx "50%" :cy "50%" :r "50%" :fill "url(#_3529512508__e)"}] [:path {:d "M53.671 31.302c-.08 0-.15.054-.186.16-.483 1.375-1.135 2.195-1.671 2.195-.308 0-.432-.343-.432-.883 0-1.344.808-4.2 1.211-5.503.048-.134.075-.275.08-.418 0-.379-.207-.566-.72-.566-.512 0-1.149.22-1.724 1.233-.201-.895-.805-1.286-1.65-1.286-.974 0-1.916.628-2.692 1.644-.776 1.016-1.685 1.354-2.373 1.188.495-1.206.676-2.11.676-2.779 0-1.051-.519-1.685-1.357-1.685-1.277 0-2.011 1.217-2.011 2.497 0 .99.447 2.008 1.436 2.503-.826 1.869-2.035 3.56-2.494 3.56-.592 0-.767-2.896-.731-4.97.017-1.188.118-1.25.118-1.611 0-.205-.136-.347-.673-.347-1.252 0-1.643 1.063-1.7 2.284a6.302 6.302 0 0 1-.216 1.368c-.527 1.872-1.605 3.291-2.31 3.291-.33 0-.415-.328-.415-.755 0-1.345.752-3.03.752-4.464 0-1.057-.462-1.724-1.336-1.724-1.025 0-2.384 1.223-3.67 3.51.424-1.75.596-3.448-.654-3.448a1.71 1.71 0 0 0-.78.202.44.44 0 0 0-.251.426c.118 1.87-1.505 6.647-3.045 6.647-.282 0-.415-.302-.415-.794 0-1.345.803-4.194 1.206-5.5.049-.142.076-.291.08-.442 0-.355-.22-.539-.72-.539-.551 0-1.146.21-1.724 1.224-.202-.895-.806-1.286-1.647-1.286-1.383 0-2.933 1.463-3.61 3.374-.91 2.547-2.744 5.006-5.211 5.006-2.24 0-3.422-1.863-3.422-4.805 0-4.253 3.122-7.725 5.436-7.725 1.108 0 1.635.705 1.635 1.786 0 1.31-.729 1.917-.729 2.414 0 .152.125.303.377.303 1.007 0 2.189-1.182 2.189-2.794 0-1.611-1.307-2.793-3.623-2.793C10.85 21 7 24.85 7 29.783c0 3.925 1.937 6.291 5.284 6.291 2.284 0 4.28-1.774 5.359-3.85.121 1.72.9 2.615 2.088 2.615 1.058 0 1.914-.628 2.568-1.736.252 1.158.919 1.727 1.787 1.727.995 0 1.824-.63 2.615-1.8-.012.917.199 1.782.995 1.782.377 0 .827-.085.907-.414.835-3.469 2.912-6.3 3.546-6.3.186 0 .236.177.236.393 0 .942-.663 2.873-.663 4.106 0 1.335.566 2.215 1.736 2.215 1.297 0 2.615-1.587 3.495-3.91.275 2.169.87 3.92 1.798 3.92 1.143 0 3.173-2.403 4.402-4.95.48.062 1.206.047 1.899-.445a6.613 6.613 0 0 0-.468 2.388c0 2.363 1.125 3.024 2.097 3.024 1.057 0 1.913-.628 2.568-1.736.216.998.767 1.724 1.783 1.724 1.588 0 2.968-1.623 2.968-2.956 0-.352-.151-.569-.329-.569zm-32.968 2.23c-.643 0-.895-.648-.895-1.61 0-1.671 1.144-4.468 2.355-4.468.527 0 .729.625.729 1.387 0 1.697-1.087 4.692-2.19 4.692zm21.973-4.993c-.382-.457-.521-1.079-.521-1.63 0-.68.248-1.255.548-1.255.299 0 .388.293.388.701 0 .682-.243 1.683-.415 2.184zm4.973 4.994c-.64 0-.891-.744-.891-1.612 0-1.614 1.143-4.466 2.364-4.466.527 0 .716.616.716 1.386 0 1.697-1.069 4.692-2.189 4.692z" :fill "#fff"}]]]

   ;; Title
   #_[:h2
    {:class ["text-xl" "font-semibold" "text-white"]}
    "Connect to Canva"]

   ;; Description
   [:div
    {:class ["flex" "flex-col" "gap-3" "text-sm" "text-gray-300" "max-w-xs"]}
    [:p "Access your Canva designs directly in the story editor."]
    [:ul
     {:class ["text-left" "space-y-2" "text-xs" "text-gray-400"]}
     [:li
      {:class ["flex" "items-start" "gap-2"]}
      [:svg
       {:xmlns "http://www.w3.org/2000/svg"
        :viewBox "0 0 20 20"
        :fill "currentColor"
        :class ["w-5" "h-5" "text-green-500" "flex-shrink-0" "mt-0.5"]}
       [:path
        {:fill-rule "evenodd"
         :d "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
         :clip-rule "evenodd"}]]
      [:span "Import designs as images or videos"]]
     [:li
      {:class ["flex" "items-start" "gap-2"]}
      [:svg
       {:xmlns "http://www.w3.org/2000/svg"
        :viewBox "0 0 20 20"
        :fill "currentColor"
        :class ["w-5" "h-5" "text-green-500" "flex-shrink-0" "mt-0.5"]}
       [:path
        {:fill-rule "evenodd"
         :d "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
         :clip-rule "evenodd"}]]
      [:span "Edit designs in Canva and sync changes"]]
     [:li
      {:class ["flex" "items-start" "gap-2"]}
      [:svg
       {:xmlns "http://www.w3.org/2000/svg"
        :viewBox "0 0 20 20"
        :fill "currentColor"
        :class ["w-5" "h-5" "text-green-500" "flex-shrink-0" "mt-0.5"]}
       [:path
        {:fill-rule "evenodd"
         :d "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
         :clip-rule "evenodd"}]]
      [:span "Browse all your Canva designs"]]]]

   ;; Connect button
   [:button
    {:class button/button-secondary-css #_["w-full" "flex" "items-center" "justify-center" "gap-2"
             "bg-gradient-to-r" "from-purple-600" "to-blue-600"
             "hover:from-purple-700" "hover:to-blue-700"
             "text-white" "font-semibold" "px-6" "py-3" "rounded-lg"
             "transition-all" "duration-200" "shadow-lg" "hover:shadow-xl"
             "transform" "hover:scale-105"]
     :type "button"
     :on {:click [[:editor2/canva-connect-click]
                  [:store/assoc-in [:editor2 :sidebar-panel] nil]]}}
    canva-icon-new
    [:span.ml-2 "Connect to Canva"]]

   ;; Help text
   [:p
    {:class ["text-xs" "text-gray-500"]}
    "You'll be redirected to Canva to authorize the connection"]])

(defn panel
  [state]
  [:div
   {:class ["flex" "flex-col" "gap-4" "w-full"]}
   (let [canva-connected? (query/get-result state {:query/kind :query/canva-status})]
     (if (:connected canva-connected?)
       (if (get-in state [:editor2 :canva/page-selection])
         (page-selection-panel state)
         (canva-panel state))
       (canva-connect-panel state)))])